import React, { useEffect, useState } from "react";
import { useForm, Controller } from 'react-hook-form';
import candidateApi from "../../services/candidateApi";
import { IoCloseOutline } from "react-icons/io5";
import { TbUserUp } from "react-icons/tb";
import { FaStar } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns"; // Use date-fns for date formatting
import { InputSwitch } from 'primereact/inputswitch';
import { BsFileEarmarkPdf } from "react-icons/bs";
import { LuUpload } from "react-icons/lu";
import { FiUser } from "react-icons/fi";
import CreatableSelect from 'react-select/creatable';
import masterApi from "../../services/masterApi";
import { MultiSelect } from "primereact/multiselect";
import Select from 'react-select';
import { ThreeDotLoader } from "../Loader/Loader";
import {
  ReferralSourceEnum, ReferralSourceEnumLabels, RecordStatusEnum,
  JobTypeEnum, JobTypeEnumLabels, EmploymentStatusEnum, EmploymentStatusEnumLabels
} from "../../enum/enum";
import apiService from "../../services/apiService";  // Import from services folder
import {toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_API_URL
const TIMEZONE_AVATAR_BASE_URL = process.env.REACT_APP_AVATAR_BASE_URL


export const CandidateForm = ({ closePopup, candidateId, editMode = false,reloadData, page }) => {
  const { control, setValue, handleSubmit, register, reset, formState: { errors },watch } = useForm({});
  const searchTextLimit = process.env.REACT_APP_CONFIDENTIAL_SEARCH_TEXT_LIMIT;
  const [isEditMode, setIsEditMode] = useState(null);
  const [qualificationLst, setQualificationLst] = useState([]);
  const [skillsLst, setSkillsLst] = useState([]);
  const [companyLst, setCompanyLst] = useState([]);
  const [accountLst, setAccountLst] = useState([]);
  const [countryLst, setCountryLst] = useState([]);
  const [stateLst, setStateLst] = useState([]);
  const [usersLst, setUsersLst] = useState([]);
  const [imagePreview, setImagePreview] = useState('');
  const [file, setFile] = useState(null);
  const [cvfile, setCVFile] = useState(null);
  const [CVfileName, setCVFileName] = useState('');
  const [companyIds, setCompanyIds] = useState([]);
  const [source, setSource] = useState(ReferralSourceEnum.OPEN);
  const [dummyValue, setDummyValue] = useState(false);
  const [recordStatus, setRecordStatus] = useState( RecordStatusEnum.ACTIVE);
  let skillsformattedData = [];
  let qualformattedData = [];
  let tagsformattedData = [];
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedCountryDetails, setSelectedCountryDetails] = useState([]);
  const [selectedNationalityDetails, setSelectedNationalityDetails] = useState([]);
  const [countryLstApi, setCountryLstApi] = useState([]);
  const [currencyLst, setCurrencyLst] = useState([]);
  const [tagsLst, setTagsLst] = useState([]);
  const [countryLstMasterApi, setCountryLstMasterApi] = useState([]);
  const [maxDOB, setMaxDOB] = useState(new Date());
  const [city, setCity] = useState('');
  const [searchedCompany, setSearchedCompany] = useState([])
const [isSubmitting, setIsSubmitting] = useState(false);
const [candidateData, setCandidateData] = useState(null)


  useEffect(() => {
    const today = new Date();
    const eighteenYearsAgo = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
    setMaxDOB(eighteenYearsAgo.toISOString().split("T")[0]); // Set maxDOB to 18 years ago from today
  }, []);

  const loadCurrencies = async () => {
      try {
        const response = await masterApi.getActiveCurrenies();  
        setCurrencyLst(response?.data?.activeCurrenies || []);      
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };
    const loadTags = async () => {
      try {
        const response = await masterApi.getActiveTags();
        // Transform the data
        tagsformattedData = response?.data?.activeTagsList?.map((tag) => ({
          label: tag.tagTitle,
          value: tag.id
        }));
        setTagsLst(tagsformattedData);
      } catch (error) {
        console.error("Error loading tags:", error);
        setTagsLst([]);
      }
    };
  const loadSkills = async () => {
    try {
      const response = await masterApi.getActiveSkill();
      // Transform the data
      skillsformattedData = response?.data?.activeSkillList?.map((skill) => ({
        label: skill.skillName,
        value: skill.id
      }));
      setSkillsLst(skillsformattedData);
    } catch (error) {
      toast.error("Error loading skills", {
        position: "top-right",
        autoClose: 2000,                   
      });
      console.error("Error loading skills:", error);
      setSkillsLst([]);
    }
  };
  
  const loadQualifications = async () => {
    try {
      const response = await masterApi.getActiveEducationalQualification();
      qualformattedData = response?.data?.activeEducationalQualificationList?.map((qual) => ({
        label: qual.title,
        value: qual.id
      }));
      setQualificationLst(qualformattedData);
    } catch (error) {
      toast.error("Error loading educational qualification", {
        position: "top-right",
        autoClose: 2000,                   
      });
      console.error("Error loading educational qualification:", error);
    }
  };
  const loadCompanies = async () => {
    try {
      // const response = await masterApi.getActiveCompanies();
      // const companyformattedData = response?.data?.companyList?.map((company) => ({
      //   name: company.companyName,
      //   code: company.id
      // }));
      const response = await apiService.getActiveCompanies(); 
      const companyformattedData = response?.map((company) => ({
       name: company.CompanyName,
       code: company.CompanyId,
       countryId:company.CountryId,
       address:company.Address,
       city:company.City,
       state:company.State,
       zipcode:company.ZipCode,
       phone:company.Phone,
       email:company.Email,
       website:company.Website,
       primaryContactFirstName:company.PrimaryContactFirstName,
       primaryContactLastName:company.PrimaryContactLastName,
       primaryContactEmail:company.PrimaryContactEmail,
       PrimaryContactPhoneNo:company.PrimaryContactPhoneNo,

      }));
      setCompanyLst(companyformattedData);
    } catch (error) {
      toast.error("Error loading componies", {
        position: "top-right",
        autoClose: 2000,                   
      });
      console.error("Error loading componies:", error);
    }
  };
  const loadusers = async () => {
    try {
      const response = await masterApi.getActiveUsers();
      const userformattedData = response?.data?.users?.map((user) => ({
        label: user.firstName + ' ' + user.lastName,
        value: user.id
      }));
      setUsersLst(userformattedData);
    } catch (error) {
      toast.error("Error loading users", {
        position: "top-right",
        autoClose: 2000,                   
      });
      console.error("Error loading users:", error);
    }
  };

  const loadAccounts = async () => {
    try {

      const response = await masterApi.getActiveProjectAccounts();
      if (response?.data && Array.isArray(response.data)) {
        const accountformattedData = response?.data.map((user) => ({
          label: user.name,
          value: user.id
        }));

        setAccountLst(accountformattedData);
      } else {
        setAccountLst([]);
      }

    } catch (error) {
      toast.error("Error loading accounts", {
        position: "top-right",
        autoClose: 2000,                   
      });
      console.error("Error loading accounts:", error);
    }
  };

  const loadCountry = async () => {
    try {        
        const response = await masterApi.getAllCountry();  
        // const response = await apiService.getAllCountry();
        // if (response && Array.isArray(response)) { 
          const countryformattedData = response?.data.map((country) => ({
            CountryId: country.id,
            CountryName: country.name,
            CountryCode:country.code,                
           }));
            setCountryLst(countryformattedData);
            
        // } else {
        //     console.error("No active country found or response format is incorrect.");
        //     setCountryLst([]);
        // }

        let responseApi = await apiService.getAllCountry();
        const countryformattedDataApi = responseApi?.map((country) => ({
          CountryId: country.CountryId,
          CountryName: country.CountryName,
          CountryCode:country.CountryCode,                
        }));
        setCountryLstApi(countryformattedDataApi);
    } catch (error) {
      toast.error("Error loading countries", {
        position: "top-right",
        autoClose: 2000,                   
      });
        console.error("Error loading countries:", error);
        setCountryLst([]);
    }
};


 // Watch the value of countryId
 const countryId = watch('countryId');  // This will watch the 'countryId' field

// Fetch states based on the selected countryId
const fetchStatesByCountryId = async (countryId) => {
  try {

    // const response = await masterApi.getStatesByCountryId(countryId);
    const response = await apiService.getStatesByCountryId(countryId);
        //console.log(response);
        // Check if activeDepartments exists in response and is an array
        // if (response?.data && Array.isArray(response.data)) {
        //   setStateLst(response.data);
        // } else {
        //     console.error("No active country found or response format is incorrect.");
        //     setCountryLst([]);
        // }
        const stateformattedData = response?.map((state) => ({
          StateId: state.StateId,
          CountryId: state.CountryId,
          StateTitle: state.StateName,    
         }));
         setStateLst(stateformattedData); 
        } catch (error) {
          toast.error("Error loading states", {
            position: "top-right",
            autoClose: 2000,                   
          });
          console.error("Error fetching states:", error);
          setStateLst([]); // In case of an error, reset the state list
        }
};


// Use useEffect to trigger state fetch when countryId changes
useEffect(() => {
  if (countryId) {
    fetchStatesByCountryId(countryId);
  }else {
    // If no country is selected (default Select), reset stateLst
    setStateLst([]);
  }
}, [countryId]); // Dependency on countryId


  useEffect(() => {
    
    const loadData = async () => {
      try {
        await loadSkills(); // Wait for loadSkills to finish
        await loadQualifications(); // Wait for loadQualifications to finish
        await loadCompanies(); // Wait for loadCompanies to finish
        await loadusers(); // Wait for loadusers to finish
        await loadAccounts();
        await loadCountry();
        await loadCurrencies();
        await loadTags();
        // await loadCustomer();
        // await loadUser();

        if (candidateId) {
          setIsEditMode(true);
        } else {
          setIsEditMode(false);
        }

        if (editMode) {
          await loadCandidateDetails(); // Wait for loadCandidateDetails to finish
        }
      } catch (error) {
        toast.error("Error loading data", {
          position: "top-right",
          autoClose: 2000,                   
        });
        console.error("Error loading data:", error);
      }
    };

    const fetchAll = async () => {
    setIsSubmitting(true);
    await loadData();
    setIsSubmitting(false);
  };
  fetchAll();
  }, []); // Empty dependency array so this runs on mount  



  const loadCandidateDetails = async () => {
    setIsSubmitting(true);
    if (editMode) {
      try{
        const response1 = await candidateApi.getCandidateById(candidateId); // API to get candidate by ID
        const data = response1?.data;
        setCandidateData(data)
        setCity(data?.city || ''); // Set initial city value
        console.log(data);
        const selectedSkills = data?.skillIds?.map((id) => {
          const matchingSkill = skillsformattedData.find((skill) => skill.value.toString() === id.toString());  
          return matchingSkill || { label: id, value: id };
        }) || [];

        const selectedCompanies = data?.companyIds.map((id, index) => ({label: data?.companyTitle?.[index], value: id}))

        const selectedQualification = data?.qualificationIds?.map((id) => {
          const matchingQual = qualformattedData?.find((qual) => qual.value.toString() === id.toString());
          return matchingQual || { label: id, value: id };
        }) || [];
      const selectedTags = (data?.tagIds || []).map((tagIds) => {  
        const matchingTag = tagsformattedData.find((tag) => tag.label === tagIds);
        return matchingTag || { label: tagIds, value: tagIds }; // value and label are both tagTitle
      });
     
      const selectedJobType = data.jobTypeIds.map((String)) ;
      if (data?.cvFilePath) {
       // Get the last part of the path (file name)
        const fileName = data?.cvFilePath.split('/').pop();
        setCVFileName(fileName);  // Set the file name to the state
      }

      setImagePreview(BASE_URL + '/' + data?.profileImagePath);
      if (!data.jobReferenceName || data.jobReferenceName.trim() === '' || data.jobReferenceName.trim() === 'null') {
        data.jobReferenceName = null;
      }

        // Update companyIds state
        setCompanyIds(data?.companyIds);
        if (data?.jobReferenceSource === 'Employee') {
          setSource('Employee');
        } else if (data?.jobReferenceSource === 'Customer') {
          setSource('Customer');
        } else {
          setSource('Open');
        }
        //setDummyValue(prev => !prev); // Toggle dummyValue  
        // debugger
        reset({  
          id: data.id,
          candidateTitle: data.candidateTitle,
          firstName: data.firstName,
          lastName: data.lastName,
          officialName: data.officialName,
          dob: data.dob ? format(new Date(data.dob), 'yyyy-MM-dd') : '',
          gender: data.gender,
          nationalityId: data.nationalityId,
          address: data.address,
          city: data.city,
          state: data.state,
          pin: data.pin,
          countryId: data.countryId,
          mobile: data.mobile,
          email: data.email,
          linkedin: data.linkedin,
          intern: data.intern === 1,
          educationQualificationId: 1,
          currentDesignation: data.currentDesignation,
          offeredDesignation: data.offeredDesignation,
          //totalExperience: data.experienceInYears || null,
          experienceInYears: data.experienceInYears,
          // experienceInMonths: data.experienceInMonths,
          experienceInMonths: data.experienceInMonths === null ? 0 : data.experienceInMonths,
          noticePeriod: data.noticePeriod,
          jobType: selectedJobType,
          willingToRelocate: data.willingToRelocate === 1 ,
          jobReferenceSource: data.jobReferenceSource,
          //jobReferenceName: data.jobReferenceName,
          referralEmpId: data?.jobReferenceSource === 'Employee' ? data.jobReferenceName : null,
          referralEmpId: data?.jobReferenceSource === 'Open' ? data.jobReferenceName : null,
          referralCustomer: data?.jobReferenceSource === 'Customer' ? data.jobReferenceName : null,
          jobReferenceDate: data.jobReferenceDate ? format(new Date(data.jobReferenceDate), 'yyyy-MM-dd') : '',
          skillIds: selectedSkills,
          currentStatus: data.employmentStatusId,
          educationQualifications: selectedQualification,
          currentctc: data.currentctc,
          expectedctc: data.expectedctc,
          // companies: data.companyIds, // Make sure it's an array
          companies: selectedCompanies, // Make sure it's an array
          notes: data.notes,
          recordStatus : data.recordStatus,
          tagIds: selectedTags,
          expectedCurrencyId: data.expectedCurrencyId,
          currentCurrencyId: data.currentCurrencyId,
          perhourcost: data.perHourCost
        });
      }
      catch (error) {
        toast.error("Error loading candidate details", {
          position: "top-right",
          autoClose: 2000,                   
        });
        console.error("Error loading candidate details:", error);
      }finally {
        setIsSubmitting(false);
      }
      
    }
  };



  useEffect(() => {
    setDummyValue(prev => !prev);
  }, [companyIds]);

  useEffect(() => {
    console.log("Updated source: ", source);
  }, [CVfileName, dummyValue, source]);
  // This useEffect will trigger when companyIds or dummyValue change
  
   // Handle changes to the referral source
  const handleRefferalSourceChange = (event) => {
    const selectedSource = event.target.value;
    setSource(selectedSource); // Update source
    const today = new Date().toISOString().split('T')[0];

    // Reset referralEmpId, referralCustomer, and date based on source
    if (selectedSource === ReferralSourceEnum.EMPLOYEE) {
      setValue("referralEmpId", ""); // Reset Employee Name field using react-hook-form's setValue
      setValue("referralCustomer", ""); // Reset Customer Name field
      setValue("jobReferenceDate", today); // Reset date field
    } else if (selectedSource === ReferralSourceEnum.CUSTOMER) {
      setValue("referralEmpId", ""); // Reset Employee Name field
      setValue("referralCustomer", ""); // Reset Customer Name field
      setValue("jobReferenceDate", today); // Reset date field
    } else {
      setValue("referralEmpId", ""); // Reset all fields
      setValue("referralCustomer", ""); // Reset all fields
      setValue("jobReferenceDate", today); // Reset all fields
    }
  };

  const getAllCountries = async () => {  
      try {
        const response = await masterApi.getAllCountry();
    
        // Make sure to access the actual country list
        const countries = response?.data || []; // or response.data.data if nested further
        return countries.map(country => ({
          countryId: country.CountryId,
          countryName: country.CountryName,
          countryCode: country.CountryCode,
        }));
      } catch (error) {
        toast.error("Error loading countries", {
          position: "top-right",
          autoClose: 2000,                    
        })
        console.error("Error loading countries:", error);
      }
    };
    
    const addCountryDetails = async (country) => {  
      try {
        const payload = {
              countries: [{
                  CountryId: country.CountryId,
                  CountryName: country.CountryName,
                  CountryCode: country.CountryCode,
              }]
      }; 
        const response = await masterApi.createCountryFromApi(JSON.stringify(payload)); 
        return response;
      } catch (error) {
        toast.error("Error loading countries", {
          position: "top-right",
          autoClose: 2000,                    
        })
        console.error("Error adding company details:", error);
      }
    };
    
    const addCountryIfNotExists = async (country) => {
      try{
        const countries = await getAllCountries();
        const countryExists = countries.some(c => c.countryId === country.CountryId);
        if (!countryExists) {
          await addCountryDetails(country);
        }
      }
      catch (error) {
        toast.error("Error loading countries", {
          position: "top-right",
          autoClose: 2000,                    
        })
        console.error("Error adding company details:", error);
      }
    };

  const addCompanyDetails = async (companies) => {
    try {
      // Prepare the payload with all company details
      // const companies = companiesArray.flat();
      const payload = {
        companies: companies.map(company => ({
          companyId: company.code,
          name: company.name,
          countryId: company.countryId,
          address: company.address,
          city: company.city,
          state: company.state,
          zipcode: company.zipcode,
          phone: company.phone,
          email: company.email,
          website: company.website,
          primaryContactFirstName: company.primaryContactFirstName,
          primaryContactLastName: company.primaryContactLastName,
          primaryContactEmail: company.primaryContactEmail,
          primaryContactPhone: company.PrimaryContactPhoneNo
        }))
      }; 
      const response = await masterApi.createCompanyFromApi(JSON.stringify(payload)); 
      return response;
    } catch (error) {
      toast.error("Error adding company details", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error adding company details:", error);
    }
  };



  const addStateDetails = async (state) => {  
    try {      
      const payload = {
            states: [{              
                StateId: state.StateId,
                CountryId: state.CountryId,
                StateTitle: state.StateTitle,
            }]
    }; 
      const response = await masterApi.createStateFromApi(JSON.stringify(payload)); 
      return response;
    } catch (error) {
      toast.error("Error adding state details", {
        position: "top-right",
        autoClose: 2000,                   
      })
      console.error("Error adding state details:", error);
    }
  };


  const onSubmit = async (data) => {   
    try {    
      setIsSubmitting(true);
      console.log(data);  // Check data content
      // Add the selected Nationality details first
      const selectedNationalityDetails = countryLstApi.find(country => Number(country.CountryId) === Number(data.nationalityId));
      try {
          const nationalityResponse = await addCountryDetails(selectedNationalityDetails);
          if (!nationalityResponse?.ok) {
              console.warn("Failed to add nationality details");
          }
      } catch (error) {
          if (error.message.includes("ID must be unique")) {
              console.warn("Duplicate country ID, continuing execution");
          } else {
          }
      }
      // Add the selected country details first
      const selectedCountryDetails = countryLstApi.find(country => Number(country.CountryId) === Number(data.countryId));
      try {
        const countryResponse = await addCountryDetails(selectedCountryDetails);
        if (!countryResponse?.ok) {
          console.warn("Failed to add country details");
        }
      } catch (error) {
        if (error.message.includes("ID must be unique")) {
          console.warn("Duplicate country ID, continuing execution");
        } else {
        }
      }      
      // Add the selected state details first
      const selectedStateDetails = stateLst.find(
        (state) => state.StateId == data.state // loose equality handles string/number
      );
      try {
        const stateResponse = await addStateDetails(selectedStateDetails);
        if (!stateResponse?.ok) {
          console.warn("Failed to add state details");
        }
      } catch (error) {
        if (error.message.includes("ID must be unique")) {
          console.warn("Duplicate state ID, continuing execution");
          
        } else {
        }
      }      
      // Add the selected company details
  if(data.companies!==false){
      const selectedCompanyDetails = data.companies
  .map(companyId => companyLst.find(company => String(company.code) === String(companyId.value)))
  .filter(Boolean); 
      for (const company of selectedCompanyDetails) {  
        const countryId = company.countryId;
        const existingCountry = countryLst.find(c => c.CountryId === Number(company.countryId));
    
        if (!existingCountry) { 
          const countryFromList = countryLstApi.find(c => Number(c.CountryId) === Number(countryId));
          if (countryFromList) {
            const country = {
              CountryId: countryFromList.CountryId,
              CountryName: countryFromList.CountryName,
              CountryCode: countryFromList.CountryCode
            };
    
          // Add the new country
          try{
            await addCountryIfNotExists(country);
          }catch (error) {
            console.error("Error adding country:", error);
            toast.error("Error adding country", {
              position: "top-right",
              autoClose: 2000,                   
            })
          }
    
          // Refresh country list after insertion
          try{
              const response = await masterApi.getAllCountry(); // <- make sure this is available
              const updatedCountryList = response?.data ?? [];
              countryLst.length = 0;
              countryLst.push(...updatedCountryList);
        
              // Update company data with latest country info
              const updatedCountry = updatedCountryList.find(c => c.CountryId === countryId);
              if (updatedCountry) {
                company.CountryName = updatedCountry.CountryName;
                company.CountryCode = updatedCountry.CountryCode;
              }
          }catch (error) {
            console.error("Error fetching country details:", error);
            toast.error("Error fetching country details", {
              position: "top-right",
              autoClose: 2000,                   
            })
          }
        }
      }
      try {
        await addCompanyDetails([company]);
        // const companyResponse = await addCompanyDetails(selectedCompanyDetails);
        // if (!companyResponse?.ok) {
        //   console.warn("Failed to add company details");
        // }
      } catch (error) {
        if (error.message.includes("ID must be unique")) {
          console.warn("Duplicate company ID, continuing execution");
        } else {
        }
      }
    }
  }
      const formData = new FormData(); 
      
      formData.append("id", data?.id || '')
      formData.append("isEmployee", false)
      formData.append("candidateTitle", data.candidateTitle);  // This should be correctly referenced
      formData.append("firstName", data.firstName);
      formData.append("lastName", data.lastName);
      formData.append("officialName", data.officialName);
      formData.append("dob", data.dob ? format(new Date(data.dob), 'yyyy-MM-dd') : null);
      formData.append("gender", data.gender);
      formData.append("nationalityId", data.nationalityId);
      formData.append("address", data.address);
      formData.append("city", data.city);
      formData.append("state", data.state);
      formData.append("pin", data.pin);
      formData.append("countryId", data.countryId);  // Assuming static value
      formData.append("mobile", data.mobile);
      formData.append("email", data.email);
      formData.append("linkedin", data.linkedin);
      // Ensure file paths or file objects are passed correctly
      if (cvfile) {
        formData.append("cv", cvfile)
        formData.append("cvFilePath", data.cvFilePath);  // Should be a file object or path
      }

      if (file) {
        formData.append("image", file)
        formData.append("profileImagePath", data.profileImagePath);  // Should be a file object or path
      }

      formData.append("intern", data.intern == true ? 1 : 0);
      formData.append("currentDesignation", data.currentDesignation);
      formData.append("offeredDesignation", data.offeredDesignation);
      formData.append("experienceInYears", data.experienceInYears || null);
      formData.append("experienceInMonths", data.experienceInMonths || null);
      formData.append("noticePeriod", data.noticePeriod);
      formData.append("jobType", JSON.stringify(data.jobType || []));  //data.jobType
      // formData.append("willingToRelocate", data.willingToRelocate == "yes" ? 1 : 0);
      formData.append("willingToRelocate", data.willingToRelocate == true ? 1 : 0);
      formData.append("jobReferenceSource", data.jobReferenceSource);
      formData.append("jobReferenceName", data.referralEmpId || data.referralCustomer || null)
      //formData.append("jobReferenceName", data.jobReferenceName);
      formData.append("jobReferenceDate", data.jobReferenceDate ? format(new Date(data.jobReferenceDate), 'yyyy-MM-dd') : ''); //data.jobReferenceDate
      const skillsArray = data.skillIds?.map((skill) => (skill.value)) || [];
      formData.append("candidateskills", JSON.stringify(skillsArray));
      const educationQualificationsArray = data.educationQualifications?.map((skill) => (skill.value)) || [];
      formData.append("educationQualifications", JSON.stringify(educationQualificationsArray));
      const companyID = data.companies?.map(company => ((company.value.toString()))) || [];
      // formData.append("candidatecompanies", JSON.stringify(data.companies || []));
      formData.append("candidatecompanies", JSON.stringify(companyID || []));
      formData.append("employmentStatusId", data.currentStatus);
      formData.append("currentCurrencyId", data.currentCurrencyId);
      formData.append("currentctc", data.currentctc);
      formData.append("expectedCurrencyId", data.expectedCurrencyId);
      formData.append("expectedctc", data.expectedctc);
      formData.append("perhourcost", data.perhourcost);

      formData.append("tagIds", JSON.stringify((data.tagIds || []).map(tag => tag.value)));
      // formData.append("featured", data.featured == true ? 1 : 0);
      formData.append("notes", data.notes);
      formData.append("recordStatus", data.recordStatus);
      let response;
      if (data.id) {
        // If ID exists, it's an update
        // const id = data.id
        response = await candidateApi.updateCandidateDetails({
          id: data.id,
          formData: formData,
        });
        if (response?.ok) {
          candidateId = null;
          editMode = false;
          toast.success('Candidate updated successfully', {
            position: "top-right",
            autoClose: 2000,
          });
          reloadData(page);
          closePopup();  // Close the popup on success
        }
      } else {
        response = await candidateApi.createCandidate({ formData }); 
        if (response?.data?.ok) {
          const response2 = await masterApi.createCountry({  });
          reloadData(page);
          closePopup();  // Close the popup on success
          toast.success('Candidate created successfully', {
            position: "top-right",
            autoClose: 2000,
          });
        }
        if (response?.data?.ok === false) {
          toast.error('Duplicate email detected. A candidate with this email already exists.', {
            position: "top-right",
            autoClose: 2000,
          });
        }
        
      }
    } catch (error) {  
      console.error("Error submitting form:", error);
      toast.error('Error submitting form', {
        position: "top-right",
        autoClose: 2000,
      });  
    }finally {
    setIsSubmitting(false);
  }
  };

  const [options, setOptions] = useState([
    { value: 'bsc', label: 'Bachelor degree in Computer Science' },
    { value: 'banana', label: 'Banana' },
    { value: 'cherry', label: 'Cherry' },
  ]);

  const handleChange = (newValue) => {
    console.log('Selected Value:', newValue);
  };

  const handleCreate = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setOptions((prev) => [...prev, newOption]);
  };


  // type & search - Skills
  const [skills, setskills] = useState([
    { value: 'banana', label: 'Banana' },
    { value: 'cherry', label: 'Cherry' },
  ]);

  const handleChangeCity = (e) => {
    if (/^[a-zA-Z]*$/.test(e.target.value)) {
      setCity(e.target.value);
    }
  };

  const handleCreateSkills = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setskills((prev) => [...prev, newOption]);
  };




  const handleCVFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCVFile(file);
      setCVFileName(file.name); // Set the filename state
    } else {
      setCVFileName(""); // Clear the filename if no file is selected
    }
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Set the file state to store the selected file
      setFile(selectedFile);

      // Generate image preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Update preview with the base64 data URL
      };
      reader.readAsDataURL(selectedFile); // Convert the file to base64
    }
  };

  return (
    <div className="popup-container xxlarge-popup">
      <div className="shadeClose"
        onClick={() => { closePopup(); }}
      ></div>
      <div className="popup-inner">
        <div className="inner-design">          
    {isSubmitting && <ThreeDotLoader />}
          <div className="popup-header d-flex align-items-center gap2">

            <h2>{editMode ? "Update Candidate" : "Create Candidate"}</h2>
            <button type="button" className="ms-auto close-btn"
              onClick={() => {
                closePopup();
              }} >
              <IoCloseOutline />
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="popup-content">
              <div className='row'>
                <div className="col-12 col-md-6 left-holder">

                  <div className="card p-3 mb-5">
                    <h6 className="float-title">Basic Details</h6>
                    <div className="row">
                      <div className="col-12 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='firstName'>First Name <span className='asterisk danger'>*</span></label>
                        <input
                          {...register("firstName", {
                            required: "First name is required",
                          })}
                          className={`${errors.firstName ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="First Name"
                          id="firstName"
                        />
                      </div>
                      <div className="col-12 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='lastName'>Last Name <span className='asterisk danger'>*</span></label>
                        <input
                          {...register("lastName", {
                            required: "Last name is required",
                          })}
                          className={`${errors.lastName ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Last Name"
                          id="lastName"
                        />
                      </div>


                      <div className="col-12 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='officialName'>Official or Passport Name <span className='asterisk danger'>*</span></label>
                        <input
                          {...register("officialName", {
                            required: "Official or Passport Name is required",
                          })}
                          className={`${errors.officialName ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Official or Passport Name"
                          id="officialName"
                        />
                      </div>



                      <div className="col-12 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='candidateTitle'>Title <span className='asterisk danger'>*</span></label>
                        <input
                          {...register("candidateTitle", {
                            required: "Title is required",
                          })}
                          className={`${errors.candidateTitle ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Title"
                          id="candidateTitle"
                        />
                      </div>
                      <div className="col-12 col-md-5 mb-4 position-relative">
                        <label className="form-label" htmlFor='postions'>Upload CV <span className='asterisk danger'>*</span></label>
                        {/* <div className="upload-holder position-relative d-flex align-items-center">
                          <input type="file" className="form-control opacity-0 position-absolute" id="postions" />
                          <div className="design-holder d-flex gap-1 ">
                            <span><BsFileEarmarkPdf /></span>
                            
                            <p className="mb-0">Upload CV</p>
                            
                            <p className="mb-0 filename-holder ellipsis">Filename.pdf</p>
                          </div>
                        </div> */}

                        <div 
                         className={`${errors.cvFilePath ? "upload-holder position-relative d-flex align-items-center is-invalid" : "fupload-holder position-relative d-flex align-items-center"
                         }`}
                         >
                          {/* Hidden file input managed by React Hook Form */}
                          <Controller
  name="cvFilePath"
  control={control}
  rules={{
    required: editMode ? false : true, // Only required when in create mode
  }}
  render={({ field }) => (
    <input
      type="file"
      className={`${errors.cvFilePath ? "form-control opacity-0 position-absolute required" : "form-control opacity-0 position-absolute"}`}
      id="positions"
      {...field}
      accept=".pdf, .doc, .docx" // Restrict file types for the file picker
      onChange={(e) => {
        const file = e.target.files[0];
        
        if (file) {
          // Check if the file type is valid (exclude Excel files)
          const validTypes = [
            'application/pdf', // PDF
            'application/msword', // DOC
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // DOCX
          ];

          const invalidTypes = [
            'application/vnd.ms-excel', // XLS
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // XLSX
          ];

          // Validate file type
          if (invalidTypes.includes(file.type)) {
            alert("Excel files are not allowed. Please upload a PDF, DOC, or DOCX file.");
            e.target.value = ''; // Clear the file input
            return;
          }

          if (!validTypes.includes(file.type)) {
            alert("Please upload a valid resume file (PDF, DOC, DOCX).");
            e.target.value = ''; // Clear the file input
            return;
          }
        }
        
        field.onChange(e); // Update form state
        handleCVFileChange(e); // Update filename state (custom handler)
      }}
    />
  )}
/>


                          <div className="design-holder d-flex gap-1">
                            <span><BsFileEarmarkPdf /></span>
                            {/* Show this before upload */}
                            {!CVfileName && <p className="mb-0">Upload CV</p>}

                            {/* Show this after upload */}
                            {CVfileName && <p className="mb-0  ellipsis">{CVfileName}</p>}
                          </div>


                          {errors.cvFilePath && (
                            <div className="invalid-feedback position-absolute mt-0">{errors.cvFilePath.message}</div>
                          )}
                        </div>


                      </div>
                      {/* <div className="col-2 col-md-1 mb-4 position-relative">
                        <label className="form-label visibility-hidden">Featured</label>
                        <div className="featured-holder d-flex align-items-center justify-content-center">
                           <div className="star-holder">
                            <Controller
                              name="featured" 
                              control={control} 
                              render={({ field }) => (
                                <>
                                  <input
                                    type="checkbox"
                                    title="featured"
                                    checked={field.value}
                                    onChange={(e) => setValue('featured', e.target.checked)} 
                                  />
                                  <span><FaStar /></span>
                                </>
                              )}
                            />
                          </div>
                        </div>
                      </div> */}
                          <div className="col-12 col-md-7 mb-4 position-relative">
                            <label className="form-label ">Tag <span className="asterisk danger">*</span></label>
                              <div className="prime-holder d-block">
                                <div className="star-holder">
                                  <Controller
                                    name="tagIds"
                                    control={control}
                                    rules={{
                                      required: "tag is required",
                                    }}
                                    render={({ field }) => (
                                      <CreatableSelect
                                      {...field}
                                      isClearable
                                      isMulti
                                      options={tagsLst} // loaded from API
                                      value={field.value}
                                      onChange={(selected) => field.onChange(selected)}
                                      onCreateOption={(newOption) => {
                                        const currentValue = Array.isArray(field.value) ? field.value : [];
                                        const newTag = { label: newOption, value: newOption };
                                        field.onChange([...currentValue, newTag]);
                                        setTagsLst(prev => [...prev, newTag]); // optionally add new tag to options
                                      }}
                                      placeholder="Search or add a new tag..."
                                      className={`w-full ${errors.tagIds ? "is-invalid" : ""}`}
                                    />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                      <div className="col-6 col-md-4 mb-4 position-relative">
  <label className="form-label" htmlFor='dob'>DOB</label>
  <input
    type="date"
    className={`form-control ${errors.dob ? "is-invalid" : ""}`}
    id="dob"
    {...register("dob")}
    max={maxDOB} // Prevent future dates
  />
</div>
                      <div className="col-6 col-md-4 mb-4 position-relative">
                        <label className="form-label" htmlFor='gender'>Gender </label>
                        <select
                          id="gender"
                          {...register("gender", { required: "Gender is required" })}
                          className={`form-select ${errors.gender ? 'is-invalid' : ''}`}
                        >
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                      <div className="col-12 col-md-4 mb-4 position-relative">
                        <label className="form-label" htmlFor='nationalityId'>Nationality <span className='asterisk danger'>*</span></label>
                        

                  <Controller
                    name="nationalityId"
                    control={control}
                    rules={{
                      required: 'Nationality is required', // Validation rule
                    }}
                    render={({ field }) => (
                      <select {...field} className={`form-select ${errors.nationalityId ? "is-invalid" : ""}`}>
                        {/* <option value="">Select Country</option>
                        {countryLst?.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))} */}
                        <option value="">Select Country</option>
                        {countryLstApi?.map((country) => (
                          <option key={country.CountryId} value={country.CountryId}>
                            {country.CountryName}
                          </option>
                        ))}
                      </select>
                    )}
                  />



                       
                      </div>


                    </div>
                    <h6 className="with-border my-3"><span>Current Address</span></h6>
                    <div className="row">
                      <div className="col-12 col-md-12 mb-4 position-relative">
                        <label className="form-label" htmlFor='jobTitle'>Address <span className='asterisk danger'>*</span></label>
                        {/* <input
                          {...register("address", {
                            required: "Address is required",
                          })}
                          className={`${errors.firstName ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Address"
                          id="Address"
                        /> */}
                        <textarea
                          className={`${errors.address ? "form-control h-75 required" : "form-control h-75"
                            }`}
                          placeholder="Address"
                          id="address"
                          {...register("address", {
                            required: "Address is required",
                          })}
                        ></textarea>
                      </div>
                      <div className="col-6 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='jobTitle'>Country <span className='asterisk danger'>*</span></label>
                        
                        <Controller
                    name="countryId"
                    control={control}
                    rules={{
                      required: 'Country is required', // Validation rule
                    }}
                    render={({ field }) => (
                      <select {...field} className={`form-select ${errors.countryId ? "is-invalid" : ""}`}>
                        {/* <option value="">Select</option>
                        {countryLst?.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))} */}
                        <option value="">Select</option>
                        {countryLstApi?.map((country) => (
                          <option key={country.CountryId} value={country.CountryId}>
                            {country.CountryName}
                          </option>
                        ))}
                      </select>
                    )}
                  />                    
                        
                        
                        
                      </div>
                      <div className="col-6 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='state'>State <span className='asterisk danger'>*</span></label>                        
                        <Controller
                    name="state"
                    control={control}
                    rules={{
                      required: 'State is required', // Validation rule
                    }}
                    render={({ field }) => (
                      <select {...field} className={`form-select ${errors.state ? "is-invalid" : ""}`}>
                        {/* <option value="">Select</option>
                        {stateLst?.map((state) => (
                                <option key={state.id} value={state.id}>
                                    {state.name}
                                </option>
                            ))} */}
                            <option value="">Select State</option>
                        {stateLst?.map((state) => (
                          <option key={state.StateId} value={state.StateId}>
                            {state.StateTitle}
                          </option>
                        ))}
                      </select>
                    )}
                  />        
                        
                      </div>
                      <div className="col-6 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='city'>City <span className='asterisk danger'>*</span></label>
                        <input
                          {...register("city", {
                            required: "City Name is required",
                          })}
                          className={`${errors.city ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="City"
                          id="city"
                          value={city} // Ensure city value is controlled
                          onChange={(e) => handleChangeCity(e)} // Update city state on change
                        />
                      </div>

                      
                      
                      <div className="col-6 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='pin'>Pin <span className='asterisk danger'>*</span></label>
                        <input
                          {...register("pin", {
                            required: "Pincode is required",
                            pattern: {
                              value: /^[A-Za-z0-9\s\-]{3,12}$/, // General pattern for PIN codes
                              message: "Invalid pin code format",
                            },
                          })}
                          className={`${errors.pin ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Pin"
                          id="pin"
                        />
                      </div>
                    </div>
                    <div className="position-relative photo-details d-flex">
                      {/* upload photo */}
                      <div className="dp-upload-wrapper position-absolute">
                        <label className="form-label" htmlFor='jobTitle'>Upload Photo </label>
                        <div className="dp-upload-holder position-relative d-flex align-items-center">
                          {/* File input is controlled manually */}
                          {/* <input
                            type="file"
                            name="profileImagePath"
                            //className="form-control opacity-0 position-absolute required"
                            className={`${errors.profileImagePath ? "form-control opacity-0 position-absolute required" : "form-control opacity-0 position-absolute"}`}
                            id="positions"
                            onChange={handleImageChange}
                          /> */}
                          <input
  type="file"
  name="profileImagePath"
  className={`${errors.profileImagePath ? "form-control opacity-0 position-absolute required" : "form-control opacity-0 position-absolute"}`}
  id="positions"
  accept="image/jpeg, image/png, image/gif" // Restrict file types to images (JPEG, PNG, GIF)
  onChange={(e) => {
    const file = e.target.files[0];
    
    if (file) {
      // Check for valid image file types (JPEG, PNG, GIF)
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
      
      if (!validTypes.includes(file.type)) {
        alert("Please upload a valid image file (JPEG, PNG, or GIF).");
        e.target.value = ''; // Reset the file input if the file is invalid
        return;
      }
    }
    
    // Call the custom handler to process the file (e.g., set the file in the form state)
    handleImageChange(e);
  }}
/>


                          <div className="design-holder d-flex">
                            <div className="design-inner">
                              {/* <span className="upload-icon">
                              <TbUserUp />
                            </span> */}
                              <div className="img-holder">
                                {/* Show default icon or image before upload */}
                                {!imagePreview && <span><TbUserUp /></span>}

                                {/* Show uploaded image preview */}
                                {imagePreview && (
                                  <img
                                    src={imagePreview}
                                    alt="Uploaded preview"
                                    className="img-fluid"
                                  />
                                )}
                              </div>
                            </div>

                          </div>
                        </div>



                      </div>

                      <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label" htmlFor='mobile'>Mobile No <span className='asterisk danger'>*</span></label>
                          <input
                            {...register("mobile", {
                              required: "Mobile Number is required",
                              // pattern: {
                              //   value: /^(?:\+|00)?[1-9]\d{0,2}[ -]?\(?\d{1,4}\)?[ -]?\d{1,4}[ -]?\d{1,4}$/,
                              //   message: "Invalid mobile number format"
                              // },
                              pattern: {
                                value:/^\+?\d{10,15}$/, // E.164 format: starts with +, followed by 10–15 digits
                                message: "Invalid mobile number format"
                              },
                            })}
                            className={`${errors.mobile ? "form-control required" : "form-control"
                              }`}
                            type="text"
                            placeholder="Mobile No"
                            id="mobile"
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <label className="form-label" htmlFor='linkedin'>LinkedIn Id </label>
                          <input
                            {...register("linkedin")}
                            className={`${errors.linkedin ? "form-control required" : "form-control"
                              }`}
                            type="text"
                            placeholder="Linked In"
                            id="linkedin"
                          />

                        </div>
                        <div className="col-12 col-md-9 mb-3">
                          <label className="form-label" htmlFor='email'>Email <span className='asterisk danger'>*</span></label>
                          <input
                            {...register("email", {
                              required: "Email is required",

                              validate: (value) => {
                                if (value) {
                                  // If email is not empty, apply validation
                                  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                                    return "Invalid email address";
                                  }
                                }
                                // If email is empty, no validation error
                                return true;
                              },

                            }
                            )}
                            className={`${errors.email ? "form-control required" : "form-control"
                              }`}
                            type="text"
                            placeholder="Email"
                            id="email"
                          />
                        </div>



                        <div className="col-12 col-md-3 mb-3">
                          <label className="form-label" htmlFor='jobTitle'>Intern </label>
                          <div className="switch-holder">
                            {/* <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} /> */}
                            <Controller
                              name="intern" // Name of the field
                              control={control}
                              defaultValue={false} // Set the default value for the switch
                              render={({ field }) => (
                                <InputSwitch
                                  {...field} // Spread the field props to InputSwitch
                                  checked={field.value} // The current state of the switch
                                  onChange={(e) => field.onChange(e.value)} // Update the value when switch changes
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>

                  <div className="card p-3">
                    <h6 className="float-title">Professional Details</h6>
                    <div className="row">
                      <div className="col-12 col-md-7 mb-4 position-relative">
                        <label className="form-label" htmlFor="educationQualifications">
                          Qualification <span className="asterisk danger">*</span>
                        </label>
                        <div className="d-block prime-holder">
                          <Controller
                            name="educationQualifications"
                            control={control}
                            rules={{ required: true }}
                            // defaultValue={selectedQualification} // Ensure this matches the format of your data
                            render={({ field }) => (
                              <CreatableSelect
                                {...field}
                                isClearable
                                options={qualificationLst}
                                value={field?.value} // Ensure value is populated
                                onChange={(selected) => field.onChange(selected)} // Sync changes
                                onCreateOption={(newOption) => {
                                  handleCreate(newOption);
                                  field.onChange([...field?.value, { label: newOption, value: newOption }]);
                                }}
                                placeholder="Search or add a new item..."
                                className={`w-full  ${errors.educationQualifications ? "is-invalid" : ""}`}
                                isMulti
                              />
                            )}
                          />
                        </div>
                        {errors.educationQualifications && (
                          <div className="invalid-feedback position-absolute mt-0" >{errors.educationQualifications.message}</div>
                        )}
                      </div>
                      <div className="col-6 col-md-5 mb-4 position-relative">
                        <label className="form-label" htmlFor='TYE'>Total year of Exp. <span className='asterisk danger'>*</span></label>
                        <div className="d-flex gap-1">
                          
                          <Controller
          name="experienceInYears" // Name of the form field
          control={control} // Pass control from useForm
          rules={{
            required: 'experienceInYears is required', // Validation rule
          }}
          render={({ field }) => (
            <select
            className={`form-select ${errors.experienceInYears ? "is-invalid" : ""}`}
              {...field} // Spread the field props to the select element
            >
              <option value="">Years</option> {/* Default option */}
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
            </select>
          )}
        />                          

<Controller
          name="experienceInMonths" // Name of the form field
          control={control} // Pass control from useForm
          render={({ field }) => (
            <select
              className="form-select"
              {...field} // Spread the field props to the select element
            >
              <option value="">Months</option> {/* Default option */}
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>              
            </select>
          )}
        />
                        </div>

                        
                      </div>
                      <div className="col-6 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='jobTitle'>Current Designation </label>
                        <input
                          {...register("currentDesignation",)}
                          className={`${errors.currentDesignation ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Current Designation"
                          id="currentDesignation"
                        />
                      </div>
                      <div className="col-6 col-md-6 mb-4 position-relative">
                        <label className="form-label" htmlFor='pin'>Preferred Designation </label>
                        <input
                          {...register("offeredDesignation",)}
                          className={`${errors.currentDesignation ? "form-control required" : "form-control"
                            }`}
                          type="text"
                          placeholder="Preferred Designation"
                          id="offeredDesignation"
                        />
                      </div>

                      <div className="col-6 col-md-4 mb-4 position-relative">
                        <label className="form-label" htmlFor='CS'>Current Status </label>
                        <select
                          className={`form-select ${errors.currentStatus ? "is-invalid" : ""}`}
                          id="priority"
                          {...register("currentStatus",
                            //{ required: "Please select a current status" }
                          )}
                        >
                          <option value="">Select </option>
                          {Object.keys(EmploymentStatusEnum).map((key) => (
                            <option key={key} value={EmploymentStatusEnum[key]}>
                              {EmploymentStatusEnumLabels[EmploymentStatusEnum[key]]}
                            </option>
                          ))}
                        </select>
                        {errors.currentStatus && (
                          <div className="invalid-feedback position-absolute mt-0">{errors.currentStatus.message}</div>
                        )}
                      </div>
                      <div className="col-6 col-md-4 mb-4 position-relative">
                        <label className="form-label" htmlFor='noticePeriod'>Notice Period In Days </label>                        
                        <input
                          {...register("noticePeriod",{
                            validate: (value, formValues) => {
                              const currentStatus = formValues.currentStatus;
                              const noticePeriod = parseInt(value, 10);
                      
                              if (currentStatus === EmploymentStatusEnum.READYTOJOIN) {
                                if (noticePeriod < 0 || isNaN(noticePeriod)) {
                                  return "Notice period cannot be negative";
                                }
                              } else {
                                if (noticePeriod <= 0 || isNaN(noticePeriod)) {
                                  return "Please enter a valid notice period greater than 0";
                                }
                              }
                      
                              return true;
                            }
                          }
                          //   {
                          //   pattern: {
                          //     value: /^[1-9]\d*$/, // Regex to allow only integers greater than 0
                          //     message: "Please enter a valid integer"
                          //   }
                          // }
                          )}
                          className={`${errors.noticePeriod ? "form-control required" : "form-control"
                            }`}
                          type="number"
                          placeholder="Notice Period"
                          id="noticePeriod"
                          min={0}
                        />
                      </div>
                      <div className="col-6 col-md-4 mb-4 position-relative">
                        <label className="form-label" htmlFor='FT'>Job Type </label>
                        {/* <select
                          className={`form-select ${errors.jobType ? "is-invalid" : ""}`}
                          id="jobtype"
                          {...register("jobType")}
                        >
                          <option value="">Select</option>
                          {Object.keys(JobTypeEnum).map((key) => (
                            <option key={key} value={JobTypeEnum[key]}>
                              {JobTypeEnumLabels[JobTypeEnum[key]]}
                            </option>
                          ))}
                        </select> */}
                        <div className="d-flex prime-holder">
                        <Controller
                          name="jobType"
                          control={control}
                          defaultValue={[]} // Set the initial state as an empty array
                          render={({ field }) => (
                          <MultiSelect
                            {...field}
                            options={Object.keys(JobTypeEnum).map((key) => ({
                              label: JobTypeEnumLabels[JobTypeEnum[key]],
                              value: JobTypeEnum[key]
                            }))}
                            display="chip"
                            placeholder="Select Job type"
                            maxSelectedLabels={3}
                            className={`w-full md:w-20rem form-control ${errors.jobType ? "is-invalid" : ""
                            }`}
                          />
                        )}
                      />
                    </div>
                    {errors.jobType && (
                      <div className="invalid-feedback position-absolute mt-0">{errors.jobType.message}</div>
                      )}
                      </div>
                      {/* <div className="col-12 col-md-6 mb-4 position-relative">
                        <label className="form-label" >
                          Willing to Relocate <span className="asterisk danger">*</span>
                        </label>
                        <div className="d-flex gap-3 align-items-center check-group px-3 py-2">
                          <div class="form-check">
                            <input class="form-check-input" type="radio" name="relocate" id="yes" checked />
                            <label class="form-check-label" for="yes">
                              Yes
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="form-check-input" type="radio" name="relocate" id="no" />
                            <label class="form-check-label" for="no">
                              No
                            </label>
                          </div>

                        </div>

                      </div> */}

                      <div className="col-12 col-md-6 mb-4 position-relative">
                        {/* <fieldset class="position-relative"> */}
                          {/* <legend className="label-legend position-absolute">  */}
                            <label className="form-label" htmlFor="employmenttype">
                            Willing to Relocate <span className="asterisk danger">*</span>
                            </label>
                          {/* </legend> */}
                          {/* <div className="control-group"> */}
                            {/* <div className="d-flex gap-3 align-items-center justify-content-between">
                              <div className="form-check">
                                <Controller
                                  name="willingToRelocate" // Name of the field
                                  control={control}
                                  defaultValue="yes" // Default value for the radio buttons
                                  rules={{ required: "Please select an option" }} // Validation rule
                                  render={({ field }) => (
                                    <>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id="yes"
                                        value="yes"
                                        checked={field.value === 'yes'} // Check if this option is selected
                                        onChange={() => field.onChange('yes')} // Update form state on change
                                      />
                                      <label className="form-check-label" htmlFor="yes">
                                        Yes
                                      </label>
                                    </>
                                  )}
                                />
                              </div>
                              <div className="form-check">
                                <Controller
                                  name="willingToRelocate"
                                  control={control}
                                  defaultValue="yes"
                                  render={({ field }) => (
                                    <>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id="no"
                                        value="no"
                                        checked={field.value === 'no'} // Check if this option is selected
                                        onChange={() => field.onChange('no')} // Update form state on change
                                      />
                                      <label className="form-check-label" htmlFor="no">
                                        No
                                      </label>
                                    </>
                                  )}
                                />
                              </div>
                            </div> */}
                            <div className="switch-holder">
                              <Controller
                                name="willingToRelocate"
                                control={control}
                                defaultValue={false} // Set the initial state
                                render={({ field }) => (
                                  <InputSwitch
                                    checked={!!field.value}
                                    onChange={(e) => field.onChange(e.value)}
                                  />
                                )}
                              />
                            </div>
                            {errors.relocate && <p className="text-danger">{errors.relocate.message}</p>} {/* Error message */}

                          {/* </div> */}
                        {/* </fieldset> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 right-holder">
                  <div className="card p-3 mb-4">
                    <h6 className="float-title">Salary Details</h6>
                    <div className="row">
                      <div className="col-6 col-md-6 position-relative mb-4">
                        <label className="form-label" htmlFor='CCTC'>Currency Type</label>
                        <Controller
                          name="currentCurrencyId"
                          control={control}            
                          render={({ field }) => (
                          <select {...field}
                            className={`form-select ${errors.currentCurrencyId ? 'is-invalid' : ''}`}
                            value={field.value} 
                            disabled={true ? candidateData?.packageIds.length > 0 : false}
                          >
                          <option value="">Select</option>
                          {currencyLst.map((currency) => (
                            <option key={currency.id} value={currency.id}>
                              {currency.name}
                            </option>
                          ))}
                          </select>
                          )} />
                      </div>
                      <div className="col-6 col-md-6 position-relative mb-4">
                        <label className="form-label" htmlFor='CCTC'>Current CTC </label>
                        <input
                          {...register("currentctc",{
                            pattern: {
                              value: /^[0-9]+(\.[0-9]{1,2})?$/,  // Regex to allow only positive numbers with optional decimal
                              message: "Please enter a valid salary (positive number)"
                            },
                          })}
                          className={`${errors.currentctc ? "form-control required" : "form-control"
                            }`}
                          type="number"
                          placeholder="Current CTC"
                          id="currentctc"
                          min={0}
                        />
                      </div>
                      <div className="col-6 col-md-6 position-relative mb-4">
                        <label className="form-label" htmlFor='CCTC'>Currency Type</label>
                          <Controller
                            name="expectedCurrencyId"
                            control={control}            
                            render={({ field }) => (
                            <select {...field}
                              className={`form-select ${errors.expectedCurrencyId ? 'is-invalid' : ''}`}
                              value={field.value} 
                              disabled={true ? candidateData?.packageIds.length > 0 : false}
                            >
                              <option value="">Select</option>
                              {currencyLst.map((currency) => (
                                <option key={currency.id} value={currency.id}>
                                  {currency.name}
                                </option>
                              ))}
                            </select>
                            )} />
                      </div>
                      <div className="col-6 col-md-6 position-relative mb-4">
                        <label className="form-label" htmlFor='expectedctc'>Expected CTC </label>
                        <input
                          {...register("expectedctc",{
                            pattern: {
                              value: /^[0-9]+(\.[0-9]{1,2})?$/,  // Regex to allow only positive numbers with optional decimal
                              message: "Please enter a valid salary (positive number)"
                            },
                          })}
                          className={`${errors.expectedctc ? "form-control required" : "form-control"
                            }`}
                          type="number"
                          placeholder="Expected CTC (INR)"
                          id="expectedctc"
                          min={0}
                        />
                      </div>
                      <div className="col-6 col-md-6 position-relative mb-4">
                        <label className="form-label" htmlFor='expectedctc'>Per hour cost(USD)</label>
                        <input
                          {...register("perhourcost",{
                            pattern: {
                              value: /^[0-9]+(\.[0-9]{1,2})?$/,  // Regex to allow only positive numbers with optional decimal
                              message: "Please enter a valid salary (positive number)"
                            },
                          })}
                          className={`${errors.perhourcost ? "form-control required" : "form-control"
                            }`}
                          type="number"
                          placeholder="Per hour cost(USD)"
                          id="perhourcost"
                          min={0}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card p-3 mb-4">
                    <h6 className="float-title">Skills</h6>
                    <div className="row">
                      <div className="col-12 col-md-12 mb-4 position-relative">
                        <label className="form-label" htmlFor="skillIds">
                          Skills <span className="asterisk danger">*</span>
                        </label>
                        <div className="d-block prime-holder">
                          <Controller
                            name="skillIds"
                            control={control}
                            rules={{
                              required: true,                           
                            }}
                            render={({ field }) => (
                              <CreatableSelect
                                {...field}
                                isClearable
                                options={skillsLst}
                                value={field?.value} // Ensure value is populated
                                onChange={(selected) => field.onChange(selected)} // Sync changes
                                // onCreateOption={(newOption) => {
                                //   handleCreate(newOption);
                                //   field.onChange([...field?.value, { label: newOption, value: newOption }]);
                                // }}
                                onCreateOption={(newOption) => {
                                  const currentValue = Array.isArray(field.value) ? field.value : [];
                                  field.onChange([...currentValue, { label: newOption, value: newOption }]);
                                }}
                                onInputChange={(inputValue, { action }) => {
                                  if (action === 'input-change') {
                                    // Handle input change here
                                    console.log('Input changed:', inputValue);
                                    // You can add your custom logic here
                                  }
                                }}
                                placeholder="Search or add a new item..."
                                className={`w-full ${errors.skillIds ? "is-invalid" : ""}`}
                                isMulti
                              />
                            )}
                          />
                        </div>
                        {errors.skillIds && (
                          <div className="invalid-feedback position-absolute mt-0" >{errors.skillIds.message}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card p-3 mb-4">
      <h6 className="float-title">Source</h6>
      <div className="row">
        <div className="col-12 col-md-12 position-relative">
          <div className="d-flex gap-3 align-items-center">
            {Object.entries(ReferralSourceEnum).map(([key, value], index) => (
              <div className="form-check" key={index}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="jobReferenceSource"
                  id={"page" + value}
                  value={value}
                  checked={source?.toLowerCase() === value?.toLowerCase()}
                  {...register("jobReferenceSource")}
                  onChange={handleRefferalSourceChange} // This triggers the state change
                />
                <label className="form-check-label" htmlFor={"page" + value}>
                  {ReferralSourceEnumLabels[value]}
                </label>
              </div>
            ))}
          </div>

          {/* {(source === ReferralSourceEnum.EMPLOYEE || source === ReferralSourceEnum.CUSTOMER) && ( */}
            <div className="row">
              {(source === ReferralSourceEnum.EMPLOYEE  || source === ReferralSourceEnum.OPEN) && (
                <div className="col-6 col-md-6 mt-3 position-relative">
                  <label className="form-label d-block" htmlFor="referralEmpId">Employee Name <span className="asterisk danger">*</span></label>
                  <input
                    {...register("referralEmpId", {
                      required: "referralEmpId Name is required",
                    })}
                    className={`${errors.referralEmpId ? "form-control required" : "form-control"
                    }`}
                    type="text"
                    placeholder="Employee Name"
                    id="referralEmpId"
                  />                  
                  {/* <Controller
                     name="referralEmpId"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "referralEmpId Name is required" }}
                    render={({ field }) => (
                  <Select
                    {...field}
                    options={optionUser}
                    classNamePrefix="react-select"
                    className={`${errors.referralEmpId ? "multi-select-holder form-control required" : "form-control"
                    }`}
                    placeholder="Employee Name"
                    value={optionUser.find(option => option.value === field.value)} // Show label
                    onChange={(selectedOption) => field.onChange(selectedOption.value)} // Store value only
                  />
                )}
                /> */}
                </div>
              )}

              {source === ReferralSourceEnum.CUSTOMER && (
                <div className="col-6 col-md-6 mt-3 position-relative">
                  <label className="form-label d-block" htmlFor="referralCustomer">Customer Name <span className="asterisk danger">*</span></label>
                  {/* <input type="text" className="form-control" /> */}
                  <input
                    {...register("referralCustomer", {
                      required: "referralCustomer Name is required",
                    })}
                    className={`${errors.referralCustomer ? "form-control required" : "form-control"
                    }`}
                    type="text"
                    placeholder="Customer Name"
                    id="referralCustomer"
                  />
                  {/* <Controller
                     name="referralCustomer"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Customer name is required" }}
                    render={({ field }) => (
                  <Select
                    {...field}
                    options={option}
                    classNamePrefix="react-select"
                    className={`${errors.referralCustomer ? "multi-select-holder form-control required" : "form-control"
                    }`}
                    placeholder="Customer Name"
                    value={option.find(option => option.value === field.value)} // Show label
                    onChange={(selectedOption) => field.onChange(selectedOption.value)} // Store value only
                  />
                )}
                /> */}
                  {/* <Controller
                    name="referralCustomer"
                    control={control}
                    render={({ field }) => (
                      <select {...field} className={`form-select ${errors.referralCustomer ? "is-invalid" : ""}`}>
                        <option value="">Select Name</option>
                        {accountLst?.map((account) => (
                          <option key={account.value} value={account.value}>
                            {account.label}
                          </option>
                        ))}
                      </select>
                    )}
                  /> */}
                </div>
              )}

              <div className="col-6 col-md-6 mt-3 position-relative">
                <label className="form-label d-block" htmlFor="date">Date</label>
                <Controller
                  name="jobReferenceDate"
                  control={control}
                  defaultValue={new Date().toISOString().split('T')[0]}
                  rules={{
                    required: "jobReferenceDate is required",                           
                  }}
                  render={({ field }) => (
                    <input
                      type="date"
                      className={`form-control ${errors.jobReferenceDate ? "is-invalid" : ""}`}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
          {/* )} */}
        </div>
      </div>
      </div>
      

                  <div className="card p-3 mb-4">
                    <h6 className="float-title">Company</h6>
                    <div className="row">
                      <label className="form-label" htmlFor="skillIds">
                            Company <span className="asterisk danger">*</span>
                      </label>
                      <div className="d-block prime-holder">
                          <Controller
                            name="companies"
                            control={control}
                            rules={{
                              required: "Please select at least one company",                           
                            }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={searchedCompany.map(company => ({label: company.name, value: company.code}))}
                                placeholder="Select Company"
                                maxSelectedLabels={3}
                                value={field.value}
                                onChange={(selected) => {
                                  // Handle both single and multi-select cases
                                  const selectedValues = selected ? (Array.isArray(selected) ? selected : [selected]) : [];
                                  field.onChange(selectedValues);
                                  // Update companyIds state if needed
                                  const companyCodes = selectedValues.map(item => item.value);
                                  setCompanyIds(companyCodes);
                                }}
                                className={`w-full md:w-20rem ${errors.companies ? "is-invalid" : ""}`}
                                // onInputChange={input => {
                                //   if(input.length >= searchTextLimit){
                                //     const matchedList = companyLst.filter(company => 
                                //       company.name.toLocaleLowerCase().startsWith(input.toLocaleLowerCase())
                                //     )
                                //     setSearchedCompany(matchedList)
                                //   }else{
                                //     setSearchedCompany([])
                                //   }
                                // }}

                                onInputChange={(inputValue) => {
                                  if (inputValue.length >= searchTextLimit) {
                                    const matchedList = companyLst.filter(company =>
                                      company.name.toLocaleLowerCase().startsWith(inputValue.toLocaleLowerCase())
                                    );
                                    setSearchedCompany(matchedList);
                                
                                    //  Optional logic: update selectedCompanies based on filtered list
                                    const matchedCodes = matchedList.map(c => Number(c.code));
                                    const currentSelectedCodes = companyIds.filter(id => matchedCodes.includes(id));
                                    const currentSelectedCompanies = matchedList.filter(c =>
                                      currentSelectedCodes.includes(Number(c.code))
                                    );
                                
                                    setCompanyIds(currentSelectedCodes); //  Sync visible selected companyIds
                                    setSelectedCompanies(currentSelectedCompanies); //  Sync selected company objects
                                  } else {
                                    setSearchedCompany([]);
                                
                                    // Optional reset (only if you want to clear when under limit)
                                    // setCompanyIds([]);
                                    // setSelectedCompanies([]);
                                  }
                                }}
                                
                                isMulti
                              />
                            )}
                          />
                        </div>
                      {/* {companyLst?.map((company) => (
                        <div key={company.code} className="col-12 col-md-4 mb-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={Number(company.code)}
                              id={`company-${company.code}`}
                              // Explicitly set `checked` based on whether the company is in `companyIds`
                              checked={companyIds.includes(Number(company.code))}
                              {...register("companies",
                                //{ required: "Please select at least one company" }
                              )}
                              onChange={(e) => {
                                const value = Number(company.code);
                                const isChecked = e.target.checked;

                                if (isChecked) {
                                  setCompanyIds((prev) => [...prev, value]); // Add to companyIds
                                  setSelectedCompanies((prev) => [...prev, company]); // Add to selectedCompanies
                                } else {
                                  setCompanyIds((prev) => prev.filter((id) => id !== value)); // Remove from companyIds
                                  setSelectedCompanies((prev) => prev.filter((c) => c.code !== value)); // Remove from selectedCompanies
                                }

                                // Update React Hook Form state
                                setValue("companies", isChecked
                                  ? [...companyIds, value]
                                  : companyIds.filter((id) => id !== value)
                                );
                                
                              }}
                            />
                            <label className="form-check-label" htmlFor={`company-${company.code}`}>
                              {company.name}
                            </label>
                          </div>
                        </div>
                      ))} */}
                    </div>

                  </div>

                  <div>
                    <label className="form-label" htmlFor="notes">
                      Notes
                    </label>
                    <textarea
                          className={`${errors.notes ? "form-control h-100 required" : "form-control h-100"
                            }`}
                          placeholder="notes"
                          id="notes"
                          {...register("notes", {                            
                          })}
                        ></textarea>
                    {/* <textarea
                      className="form-control h-100"
                      placeholder="Notes"

                    ></textarea> */}
                  </div>

                  {editMode && (
  <div className="col-6 col-md-4 mb-3">
    <label className="form-label" htmlFor="department">
      Status <span className="asterisk danger">*</span>
    </label>
    <Controller
      name="recordStatus"
      control={control}
      defaultValue={recordStatus} // Default value
      // rules={{ required: "Status is required" }}
      render={({ field }) => (
        <select
          {...field}
          id="status"
          className="form-select"
          aria-label="recordStatus"
        >
          {/* <option value="" disabled>
            Select Status
          </option> */}
          {Object.entries(RecordStatusEnum)
          .filter(([key, value]) => value !== "Deleted")
          .map(([key, value]) => (
            <option key={key} value={value}>
              {value}
            </option>
          ))}
        </select>
      )}
    />
  </div>
)}


                </div>





              </div>

            </div>

            <div className='popup-footer position-absolute w-100 d-flex'>
              <div className='ms-auto d-flex gap-2'>
                <button type="button" className="btn btn-dark btn-lg"
                  onClick={() => { closePopup(); }}
                >Cancel</button>
                <button type="submit" className="btn btn-success btn-lg"  > {editMode ? "Update" : "Create New"}</button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

